import React from "react";
import { Link } from "react-router-dom";
import "./style/PageContent.css";

function LandingPage({ about, projects }) {
  const featuredProjects = projects.slice(0, 3);

  return (
    <div className="page-content">
      <h1 className="page-title">Jake Livingston</h1>
      <p className="page-description">
        Software engineer focused on practical tools, game development, and
        shipping useful things with small teams.
      </p>
      <p className="page-description">
        Based in Portland, Oregon. This site collects projects, background, and
        a clearer snapshot of what I have been building.
      </p>
      <div className="page-section">
        <h2>Current Snapshot</h2>
        <p className="page-description">{about.background.split("\n\n")[0]}</p>
      </div>
      <div className="page-section">
        <h2>Featured Projects</h2>
        <ul className="page-list">
          {featuredProjects.map((project) => (
            <li key={project.slug}>
              <Link to={`/projects/${project.slug}`}>{project.name}</Link>
              {`: ${project.shortDescription}`}
            </li>
          ))}
        </ul>
        <Link className="page-link" to="/projects">
          View all projects
        </Link>
      </div>
    </div>
  );
}

export default LandingPage;
